"use client";
import { Category } from "@/models/category";
import { paramsEX } from "@/models/Params";
import CategoryService from "@/services/main/categoryWpServices";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type CategoriesProps = {
  params?: Partial<paramsEX>;
  options?: Omit<
    UseQueryOptions<Category[], unknown, Category[]>,
    "queryKey" | "queryFn"
  >;
};

export const useCategoriesQuery = ({ params, options }: CategoriesProps) => {
  return useQuery<Category[], unknown>({
    queryKey: ["categories-wp", params],
    queryFn: async () => {
      const result = await CategoryService.findAll(params);
      return result;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};
